import clsx from "clsx";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { IntegrationMasterForm } from "../types/form-inputs.ts";
import { CardLayout } from "./CardLayout.tsx";
import { Field } from "./catalyst/Field.tsx";
import { Label } from "./catalyst/Label.tsx";
import { Textarea } from "./catalyst/Textarea.tsx";
import FileUploadButton from "./inputs/FileUploadButton.tsx";
import InputFieldGroup from "./inputs/InputFieldGroup.tsx";

export const IntegrationBasicDetails: FC<{
  allowIcon?: boolean;
  nameLabel: string;
}> = ({ allowIcon = true, nameLabel }) => {
  const methods = useFormContext<IntegrationMasterForm>();

  const {
    control,
    formState: { errors },
    register,
  } = methods;

  return (
    <>
      <CardLayout header={<>Add New Data Source</>}>
        <div className="mt-10 grid grid-cols-8 gap-x-6 gap-y-8 sm:grid-cols-8">
          <div className={clsx(allowIcon ? "sm:col-span-6" : "sm:col-span-8")}>
            <InputFieldGroup<IntegrationMasterForm>
              errors={errors}
              fieldName="connectionName"
              label={`${nameLabel} Name`}
              placeHolder={`Unique ${nameLabel} Name`}
              register={register}
              rules={{
                required: `Please enter a ${nameLabel} name`,
              }}
            />
          </div>

          {allowIcon && (
            <div className="sm:col-span-2">
              <Controller
                control={control}
                name="iconUrl"
                render={({ field: { onChange, value } }) => (
                  <FileUploadButton
                    onUpload={onChange}
                    showImageIcon={true}
                    uploadedUrl={value}
                  />
                )}
              />
            </div>
          )}
          <div className="col-span-full">
            <Field>
              <Label>Description (Optional)</Label>
              <Textarea {...register("description")} />
            </Field>
          </div>
        </div>
      </CardLayout>
    </>
  );
};
